import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';

import './card-remove-overlay.scss';

export function CardRemoveOverlay({
  toggleOverlay,
  removeCard,
  trackingId = '',
  trackingValue = '',
  textLabel = 'this car',
  ariaLabel = 'this car',
}) {
  const removeRef = useRef();

  useEffect(() => {
    removeRef.current.focus();
  }, []);

  function handleEscape(event) {
    if (event.keyCode === 27) {
      toggleOverlay();
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <div
      role="dialog"
      aria-label={`Are you sure you want to remove ${ariaLabel}?`}
      className="card-remove-overlay rounded pos-a top-0 left-0 h-100 w-100 px-1 text-center d-flex flex-column justify-content-center"
      tabIndex={-1}
      onKeyUp={handleEscape}
    >
      <p className="text-white size-16">Are you sure you want to remove {textLabel}?</p>
      <div>
        <Button
          className="btn-bg-white text-capitalize size-16 mx-0_25"
          size="sm"
          color="outline-primary-b"
          onClick={removeCard}
          data-tracking-id={trackingId}
          data-tracking-value={trackingValue}
          data-tracking-disabled={!trackingId}
          innerRef={removeRef}
        >
          <span className="fw-normal">
            Remove<span className="visually-hidden"> this car</span>
          </span>
        </Button>
        <Button className="text-capitalize text-white size-16 mx-0_25" size="sm" color="link" onClick={toggleOverlay}>
          <span className="fw-normal">
            Cancel<span className="visually-hidden"> removing this car</span>
          </span>
        </Button>
      </div>
    </div>
  );
}

CardRemoveOverlay.propTypes = {
  toggleOverlay: PropTypes.func.isRequired,
  removeCard: PropTypes.func.isRequired,
  trackingValue: PropTypes.string,
  trackingId: PropTypes.string,
  textLabel: PropTypes.string,
  ariaLabel: PropTypes.string,
};
